import type {
  UnableToCompleteReasonCatalogAdoptionListApiData,
  UnableToCompleteReasonCatalogAdoptionListApiResponses,
  UnableToCompleteReasonCatalogBulkAdoptApiData,
  UnableToCompleteReasonCatalogBulkAdoptApiResponses,
  UnableToCompleteReasonCatalogBulkDeleteAdoptionsApiData,
  UnableToCompleteReasonCatalogBulkDeleteAdoptionsApiResponses,
  UnableToCompleteReasonCatalogEntryAdoptApiData,
  UnableToCompleteReasonCatalogEntryAdoptApiResponses,
  UnableToCompleteReasonCatalogEntryCreateApiData,
  UnableToCompleteReasonCatalogEntryCreateApiResponses,
  UnableToCompleteReasonCatalogEntryDeleteApiData,
  UnableToCompleteReasonCatalogEntryDeleteApiResponses,
  UnableToCompleteReasonCatalogEntryGetApiData,
  UnableToCompleteReasonCatalogEntryGetApiResponses,
  UnableToCompleteReasonCatalogEntryListApiData,
  UnableToCompleteReasonCatalogEntryListApiResponses,
  UnableToCompleteReasonCatalogEntryPatchApiData,
  UnableToCompleteReasonCatalogEntryPatchApiResponses,
  UnableToCompleteReasonCreateApiData,
  UnableToCompleteReasonCreateApiResponses,
  UnableToCompleteReasonCreateFromTemplatesApiData,
  UnableToCompleteReasonCreateFromTemplatesApiResponses,
  UnableToCompleteReasonDeleteApiData,
  UnableToCompleteReasonDeleteApiResponses,
  UnableToCompleteReasonGetApiData,
  UnableToCompleteReasonGetApiResponses,
  UnableToCompleteReasonListApiData,
  UnableToCompleteReasonListApiResponses,
  UnableToCompleteReasonPatchApiData,
  UnableToCompleteReasonPatchApiResponses,
  UnableToCompleteReasonsBulkDeleteApiData,
  UnableToCompleteReasonsBulkDeleteApiResponses,
  UnableToCompleteReasonsBulkPatchApiData,
  UnableToCompleteReasonsBulkPatchApiResponses,
  UnableToCompleteTagCreateApiData,
  UnableToCompleteTagCreateApiResponses,
  UnableToCompleteTagDeleteApiData,
  UnableToCompleteTagDeleteApiResponses,
  UnableToCompleteTagListApiData,
  UnableToCompleteTagListApiResponses,
  UnableToCompleteTagPatchApiData,
  UnableToCompleteTagPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getUnableToCompleteUrls = {
  getPaginatedUnableToCompleteTags: dataEndpoint<UnableToCompleteTagListApiData, UnableToCompleteTagListApiResponses>({
    getUrl: (queryParams) => apiUrl('unable-to-complete-tags/', queryParams)
  }),
  postCreateUnableToCompleteTag: responseEndpoint<
    UnableToCompleteTagCreateApiData,
    UnableToCompleteTagCreateApiResponses
  >({
    getUrl: () => apiUrl('unable-to-complete-tags/'),
    getBody: (data) => data
  }),
  patchUnableToCompleteTag: responseEndpoint<UnableToCompleteTagPatchApiData, UnableToCompleteTagPatchApiResponses>({
    getUrl: ({ unableToCompleteTagId }) => apiUrl(`unable-to-complete-tags/${unableToCompleteTagId}/`),
    getBody: (data) => data
  }),
  deleteUnableToCompleteTag: dataEndpoint<UnableToCompleteTagDeleteApiData, UnableToCompleteTagDeleteApiResponses>({
    getUrl: ({ unableToCompleteTagId }) => apiUrl(`unable-to-complete-tags/${unableToCompleteTagId}/`)
  }),
  getPaginatedUnableToCompleteReasonsV2: dataEndpoint<
    UnableToCompleteReasonListApiData,
    UnableToCompleteReasonListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/unable-to-complete-reasons-v2/', queryParams)
  }),
  postCreateUnableToCompleteReasonsFromTemplate: responseEndpoint<
    UnableToCompleteReasonCreateFromTemplatesApiData,
    UnableToCompleteReasonCreateFromTemplatesApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reasons/create-from-templates/'),
    getBody: (data) => data
  }),
  getUnableToCompleteReason: dataEndpoint<UnableToCompleteReasonGetApiData, UnableToCompleteReasonGetApiResponses>({
    getUrl: ({ reasonId }) => apiUrl(`bookings/unable-to-complete-reasons/${reasonId}/`)
  }),
  postUnableToCompleteReason: responseEndpoint<
    UnableToCompleteReasonCreateApiData,
    UnableToCompleteReasonCreateApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reasons-v2/'),
    getBody: (data) => data
  }),
  patchUnableToCompleteReason: responseEndpoint<
    UnableToCompleteReasonPatchApiData,
    UnableToCompleteReasonPatchApiResponses
  >({
    getUrl: ({ reasonId }) => apiUrl(`bookings/unable-to-complete-reasons/${reasonId}/`),
    getBody: (data) => data
  }),
  deleteUnableToCompleteReason: dataEndpoint<
    UnableToCompleteReasonDeleteApiData,
    UnableToCompleteReasonDeleteApiResponses
  >({
    getUrl: ({ reasonId }) => apiUrl(`bookings/unable-to-complete-reasons/${reasonId}/`)
  }),
  postDeleteBulkUnableToCompleteReasons: responseEndpoint<
    UnableToCompleteReasonsBulkDeleteApiData,
    UnableToCompleteReasonsBulkDeleteApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reasons/bulk-delete/'),
    getBody: (data) => data
  }),
  patchBulkUnableToCompleteReasons: responseEndpoint<
    UnableToCompleteReasonsBulkPatchApiData,
    UnableToCompleteReasonsBulkPatchApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reasons/bulk-patch/'),
    getBody: (data) => data
  }),
  getPaginatedUnableToCompleteCatalogEntries: dataEndpoint<
    UnableToCompleteReasonCatalogEntryListApiData,
    UnableToCompleteReasonCatalogEntryListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/unable-to-complete-reason-catalog-entries/', queryParams)
  }),
  getUnableToCompleteCatalogEntry: dataEndpoint<
    UnableToCompleteReasonCatalogEntryGetApiData,
    UnableToCompleteReasonCatalogEntryGetApiResponses
  >({
    getUrl: ({ catalogEntryId }) => apiUrl(`bookings/unable-to-complete-reason-catalog-entries/${catalogEntryId}/`)
  }),
  postUnableToCompleteCatalogEntry: responseEndpoint<
    UnableToCompleteReasonCatalogEntryCreateApiData,
    UnableToCompleteReasonCatalogEntryCreateApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reason-catalog-entries/'),
    getBody: (data) => data
  }),
  patchUnableToCompleteCatalogEntry: responseEndpoint<
    UnableToCompleteReasonCatalogEntryPatchApiData,
    UnableToCompleteReasonCatalogEntryPatchApiResponses
  >({
    getUrl: ({ catalogEntryId }) => apiUrl(`bookings/unable-to-complete-reason-catalog-entries/${catalogEntryId}/`),
    getBody: (data) => data
  }),
  deleteUnableToCompleteCatalogEntry: responseEndpoint<
    UnableToCompleteReasonCatalogEntryDeleteApiData,
    UnableToCompleteReasonCatalogEntryDeleteApiResponses
  >({
    getUrl: ({ catalogEntryId, ...queryParams }) =>
      apiUrl(`bookings/unable-to-complete-reason-catalog-entries/${catalogEntryId}/`, queryParams)
  }),
  postAdoptUnableToCompleteCatalogEntry: responseEndpoint<
    UnableToCompleteReasonCatalogEntryAdoptApiData,
    UnableToCompleteReasonCatalogEntryAdoptApiResponses
  >({
    getUrl: ({ catalogEntryId }) =>
      apiUrl(`bookings/unable-to-complete-reason-catalog-entries/${catalogEntryId}/adopt/`),
    getBody: (data) => data
  }),
  getPaginatedUnableToCompleteCatalogAdoptions: dataEndpoint<
    UnableToCompleteReasonCatalogAdoptionListApiData,
    UnableToCompleteReasonCatalogAdoptionListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/unable-to-complete-reason-catalog-entries/adoptions/', queryParams)
  }),
  postBulkAdoptUnableToCompleteCatalogEntry: responseEndpoint<
    UnableToCompleteReasonCatalogBulkAdoptApiData,
    UnableToCompleteReasonCatalogBulkAdoptApiResponses
  >({
    getUrl: ({ catalogEntryId }) =>
      apiUrl(`bookings/unable-to-complete-reason-catalog-entries/${catalogEntryId}/adoptions/`),
    getBody: (data) => data
  }),
  postBulkDeleteUnableToCompleteCatalogAdoptions: responseEndpoint<
    UnableToCompleteReasonCatalogBulkDeleteAdoptionsApiData,
    UnableToCompleteReasonCatalogBulkDeleteAdoptionsApiResponses
  >({
    getUrl: () => apiUrl('bookings/unable-to-complete-reason-catalog-entries/adoptions/delete/'),
    getBody: (data) => data
  })
};
